import React, { useContext } from "react";
import { Row, Spin, Col, Card, Statistic, Alert, Typography } from "antd";
import {
  LoadingOutlined,
  BookOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  TrophyOutlined,
  SafetyCertificateOutlined,
  StarOutlined
} from "@ant-design/icons";
import useSelfDashboard from "PlatForms/SelfLMS/Hooks/SelfLearner/useSelfDashboard";
import { SelfHeader } from "./SelfHeader";
import useAvailableCourses from "PlatForms/SelfLMS/Hooks/Courses/useCourses";
import EnrolledCoursesCard from "./EnrolledCourseCard";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import ProfileIncompleteAlert from "Common/Components/ProfileIncompleteAlert";
import SimplifiedInterestAlert from "./InterestAlert";
import RecommendedCoursesCard from "./RecomendedCourseCard";

const SelfLandingPage = () => {
  const { isProfileComplete, loading: profileLoading } = useContext(ProfileContext);
  const { dashboardData, interest, loading, error } = useSelfDashboard();
  const { courses, loading: coursesLoading } = useAvailableCourses();

  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#1890ff" }} spin />;

  if (loading || coursesLoading || profileLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <Spin indicator={spinnerIcon} tip="Loading..." />
      </div>
    );
  }

  if (error || !dashboardData) {
    return <div style={{ padding: 20 }}>{error ? `⚠️ Error: ${error}` : "No data available"}</div>;
  }

  return (
    <div style={{ padding: "12px 24px" }}>
      {/* Passing learner data to Header for Image and Greeting */}
          <SelfHeader 
      userName={`${dashboardData.learner.firstName} ${dashboardData.learner.lastName}`}
        learnerCode={dashboardData.learner.learnerCode} 

    />


      <div>
        {!isProfileComplete && <ProfileIncompleteAlert navigateTo="/selfLearner-profile" />}
        
        <SimplifiedInterestAlert interests={interest || []} />

        {/* Recommended Courses Notification Section */}

{/* Recommended Courses Card */}
{dashboardData.recommendedCourses && dashboardData.recommendedCourses.length > 0 && (
  <RecommendedCoursesCard 
    recommendedCourses={dashboardData.recommendedCourses}
    style={{ marginBottom: '20px' }}
  />
)}

        {/* Statistics Cards - Reduced padding and size */}
    <Row
  gutter={[12, 12]}
  style={{
    marginBottom: "16px",
    opacity: isProfileComplete ? 1 : 0.5,
    pointerEvents: isProfileComplete ? 'auto' : 'none'
  }}
>
  {[
    { title: "Enrolled", value: dashboardData.enrollmentCount, icon: <BookOutlined />, color: '#1890ff' },
    { title: "Completed", value: dashboardData.enrollmentCompletedCount, icon: <CheckCircleOutlined />, color: '#52c41a' },
    { title: "In Progress", value: dashboardData.enrollmentInprogressCount, icon: <ClockCircleOutlined />, color: '#faad14' },
    { title: "Progress", value: dashboardData.progress ? parseFloat(dashboardData.progress).toFixed(1) : 0, icon: <TrophyOutlined />, color: '#722ed1', suffix: "%" },
    { title: "Certificates", value: dashboardData.totalCertificates || 0, icon: <SafetyCertificateOutlined />, color: '#eb2f96' },
  ].map((item, idx) => (
    <Col key={idx} xs={12} sm={8} md={6} lg={4} xl={4}>
      <Card size="small" bodyStyle={{ padding: '12px' }}>
        <Statistic
          title={<span style={{ fontSize: '12px' }}>{item.title}</span>}
          value={item.value}
          suffix={item.suffix}
          prefix={React.cloneElement(item.icon, { style: { fontSize: '16px' } })}
          valueStyle={{ color: item.color, fontSize: '18px' }}
        />
      </Card>
    </Col>
  ))}
</Row>


        <div style={{ opacity: isProfileComplete ? 1 : 0.5 }}>
          <EnrolledCoursesCard availableCourses={courses} />
        </div>
      </div>
    </div>
  );
};

export default SelfLandingPage;